import React from "react";
import StoreWalletComp from "../../components/Store/StoreWallet";

export default function StoreWallet() {
  return <StoreWalletComp />;
}
